module.exports = __webpack_public_path__ + "static/img/b4.269a6709.png";